export const VEHICLE_FORM_EVENTS = {
  START_WATCHING: 'START_WATCHING',
  STOP_WATCHING: 'STOP_WATCHING',
  MAKE_FIELD_CHANGED: 'MAKE_FIELD_CHANGED',
  MODEL_FIELD_CHANGED: 'MODEL_FIELD_CHANGED',
  TYPE_FIELD_CHANGED: 'TYPE_FIELD_CHANGED',
  FUEL_TYPE_CHANGED: 'FUEL_TYPE_CHANGED',
  VIN_DECODED_SUCCESS: 'VIN_DECODED_SUCCESS',
  VIN_DECODE_FAILED: 'VIN_DECODE_FAILED',
  DECODE_VIN: 'DECODE_VIN',
  CREATE_CUSTOM_MAKE: 'CREATE_CUSTOM_MAKE',
  CREATE_CUSTOM_MODEL: 'CREATE_CUSTOM_MODEL',
  CHECK_PRODUCTION_YEAR: 'CHECK_PRODUCTION_YEAR',
  PRODUCTION_YEAR_CHECK_SUCCESS: 'PRODUCTION_YEAR_CHECK_SUCCESS',
  PRODUCTION_YEAR_CHECK_FAILED: 'PRODUCTION_YEAR_CHECK_FAILED',
  FEATURES_AUTOFILL_SUCCESS: 'FEATURES_AUTOFILL_SUCCESS',
  VEHICLE_VARIANT_UPDATE: 'VEHICLE_VARIANT_UPDATE',
  VEHICLE_ID_UPDATE: 'VEHICLE_ID_UPDATE',
  LAST_REPLACEMENT_DATE_CHANGED: 'LAST_REPLACEMENT_DATE_CHANGED',
  LAST_REPLACEMENT_DATE_INTERVAL_CHANGED: 'LAST_REPLACEMENT_DATE_INTERVAL_CHANGED',
  LAST_REPLACEMENT_MILEAGE_CHANGED: 'LAST_REPLACEMENT_MILEAGE_CHANGED',
  LAST_REPLACEMENT_MILEAGE_INTERVAL_CHANGED: 'LAST_REPLACEMENT_MILEAGE_INTERVAL_CHANGED',
  SERVICE_INSPECTIONS_DATE_CHANGED: 'SERVICE_INSPECTIONS_DATE_CHANGED',
  SERVICE_INSPECTIONS_DATE_INTERVAL_CHANGED: 'SERVICE_INSPECTIONS_DATE_INTERVAL_CHANGED',
  SERVICE_INSPECTIONS_MILEAGE_CHANGED: 'SERVICE_INSPECTIONS_MILEAGE_CHANGED',
  SERVICE_INSPECTIONS_MILEAGE_INTERVAL_CHANGED: 'SERVICE_INSPECTIONS_MILEAGE_INTERVAL_CHANGED',
  FLUID_REPLACEMENT_DATE_CHANGED: 'FLUID_REPLACEMENT_DATE_CHANGED',
  FLUID_REPLACEMENT_MONTHS_CHANGED: 'FLUID_REPLACEMENT_MONTHS_CHANGED',
  PHOTOS_PRESET_SUCCESS: 'PHOTOS_PRESET_SUCCESS',
  CARBON_DIOXIDE_EMISSION_CHANGED: 'CARBON_DIOXIDE_EMISSION_CHANGED',
  CARBON_DIOXIDE_EMISSION_DISCHARGED_CHANGED: 'CARBON_DIOXIDE_EMISSION_DISCHARGED_CHANGED',
  CARBON_DIOXIDE_EMISSION_WEIGHTED_COMBINED_CHANGED:
    'CARBON_DIOXIDE_EMISSION_WEIGHTED_COMBINED_CHANGED',
} as const;
